import React from 'react'
import { useContext } from 'react'
import { Context } from '../../../context/app-context'
import { jsonToHash } from '../../../utils/crypto'
import getUserInfo from '../../../utils/getUserInfo'
import { pushEventData } from '../../../utils/pushEventDataLayer'
import './terms-section.scss'
const TermsSection = () => {
  const { dispatch } = useContext(Context)
  const userInfo = getUserInfo()
  const handlerTag = async evt => {
    pushEventData({
      event: 'Interacciones_Home_UCole',
      label: 'terminos y condiciones',
      user_data: userInfo && [
        await jsonToHash({
          nombre: userInfo.name,
          apellido: userInfo.lastName,
          celular: userInfo.cellPhone,
          correo: userInfo.email,
          ciudad: userInfo.location.cityName,
          departamento: userInfo.location.countryStateName,
          pais: userInfo.countryName,
        }),
      ],
      log_status: userInfo ? 'Yes' : 'Not',
    })
  }
  const openTermsModal = () => {
    dispatch({
      type: 'set-modal',
      modalActive: {
        type: 'terms',
        wrapperProps: {
          className: 'f-modalTerms',
          blur: true,
        },
      },
    })
  }
  return (
    <div className="f-terms-section">
      <a
        className="f-terms-section__aTerminos"
        onClick={evt => {
          handlerTag(evt)
          openTermsModal()
        }}
      >
        Términos y condiciones del juego
      </a>
    </div>
  )
}

export default TermsSection
